<template>
  <div id="contenu">
	<div class="head">
		<img src="../../../public/img/logo-nuhou-2048-transparent.png" alt="Logo" style="width: 5vw;"/>
		<button class="login-button" onclick="location.href='https://www.ideal360.fr/nous-contacter/'"><b>NOUS CONTACTER</b></button>
	</div>
    <div class="body">
      <component :is="layout">
      </component>
    </div>
	<div class="foot">
		<div class="copyright">
			<img src="../../../public/img/logo-nuhou-2048-transparent-blanc.png" alt="Logo" style="width: 10vw;"/>
			<p>©2024 Nuhou - Tous droits réservés</p>
		</div>
		<div class="contact">
			<h2>Vous êtes une collectivité</h2>
			<button class="login-button" onclick="location.href='https://www.ideal360.fr/nous-contacter/'"><b>NOUS CONTACTER</b></button>
		</div>
		<div class="download">
			<h2>Téléchargement</h2>
			<a href="https://apps.apple.com/us/app/id6456410066"><img src="../../../public/img/download-ios.png" alt="Logo" style="width: 155px;"/></a>
			<a href="https://play.google.com/store/apps/details?id=fr.idealsolutions.nuhou"><img src="../../../public/img/download-android.png" alt="Logo" style="width: 180px;"/></a>
		</div>
		<div></div>
		<div></div>
	</div>
  </div>
</template>
<script>
import script from '../../script/script.js';
import Menu from './Menu.vue';
import 'vue-sidebar-menu/dist/vue-sidebar-menu.css';
export default {
  data() {
    return {
	  
    }
  },
  mounted:function(){
  },
  methods: {
  },
  components: {
  },
  computed:{
    layout(){
      return(this.$route.meta.layout)+'-layout';
    }
  }
  
}
</script>
<style scoped>

.v-sidebar-menu-client .collapse-btn{
	background-color:transparent;
	outline:none;
}

.v-sidebar-menu-client .vsm-item.first-item.active-item>.vsm-link>.vsm-icon, .v-sidebar-menu-client .vsm-item.first-item>.vsm-link>.vsm-icon{
	background-color:transparent;
}

.v-sidebar-menu-client{
	max-width: 12vw;
	background-color:#808285;
	position: absolute;
	height: 94%;
	top: 6%;
}

.v-sidebar-menu-client div:nth-child(2){
	max-width: 12vw;
}

.v-sidebar-menu-client .vsm-link{
	font-size:13px;
}

#contenu{
	display: flex;
	flex-wrap: wrap;
}

.logo{
  margin-bottom: 30px;
}

.logo img {
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 35%;
  /* Adjust as needed */
}

.login-button {
  background-color: #ffa500;
  /* Customize to match your brand */
  color: white;
  border: none;
  padding: 1rem 2rem;
  margin-top: 1rem;
  cursor: pointer;
  border-radius: 20px;
  /* Rounded corners for the button */
}

.head{
	width: 100%;
    display: flex;
    flex-direction: row;
    /* flex-wrap: nowrap; */
    align-content: space-around;
    justify-content: space-around;
    align-items: center;
    padding: 1rem;
    background: white;
}

.foot{
	color: white;
	width: 100%;
    display: flex;
    flex-direction: row;
    /* flex-wrap: nowrap; */
    align-content: space-around;
    justify-content: space-around;
    align-items: center;
    padding: 1rem;
    background: #ffa500;
}

.foot .login-button {
  background-color: white;
  /* Customize to match your brand */
  color: #ffa500;
  border: none;
  padding: 1rem 2rem;
  margin-top: 1rem;
  cursor: pointer;
  border-radius: 20px;
  /* Rounded corners for the button */
}

.download,.copyright,.contact{
	display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.body{
	width: 95%;
    margin: auto;
    padding: 1em;
}
</style>